<template>
  <div>
    <v-card :loading="checkLoading">
      <v-card-title>
        <v-row no-gutters class="align-center">
          <v-btn variant="text" icon="mdi-chevron-left" @click="onPrevWeekClicked()" />
          <v-spacer></v-spacer>
          <div class="week-title">
            {{ weekTitle() }}
          </div>
          <v-spacer></v-spacer>
          <v-btn variant="text" icon="mdi-chevron-right" @click="onNextWeekClicked()"> </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text style="overflow: auto">
        <FullCalendar class="timesheet-calendar" :options="calendarOptions" ref="fullCalendar">
          <template v-slot:eventContent="arg">
            <div class="event total-hours" v-if="arg.event.extendedProps.type === 'total-hours'">
              <div class="event-container">
                <v-tooltip location="top" show width="300" class="event-tooltip-container">
                  <template v-slot:activator="{ props }">
                    <div v-bind="props" class="event__header">
                      {{ arg.event.title }}
                    </div>
                  </template>
                  <div class="event-tooltip" v-if="arg.event.extendedProps.originalObject && arg.event.extendedProps.originalObject.length > 0">
                    <div class="commitment" v-for="c of arg.event.extendedProps.originalObject" :key="c.commitmentName">
                      &nbsp;{{ c.Name }} : {{ hoursOfCommitment(c.id, arg.event.start.getDay()) }} Hours
                    </div>
                  </div>
                  <div class="event-tooltip" v-else>There are no any data</div>
                </v-tooltip>
              </div>
            </div>
            <div
              class="event main-event"
              v-else-if="arg.event.extendedProps.type === 'leave' || arg.event.extendedProps.type === 'timesheet'"
              :style="{ background: `${arg.event.backgroundColor} !important` }"
            >
              <div class="event__title">
                <span>
                  {{ arg.event.extendedProps.type === "timesheet" ? "Timesheet" : "Leave" }}
                </span>
              </div>
              <div class="event__body">
                <div class="event__name">
                  {{ arg.event.title }}
                </div>
                <div class="event__description">
                  {{ arg.event.extendedProps.description }}
                </div>
              </div>
              <div class="event__action mr-3">
                <v-tooltip top v-if="!isLessThanSixDays(arg.event.end)">
                  <template v-slot:activator="{ props }">
                    <v-icon
                      v-bind="props"
                      :disabled="true"
                      class="action-icon"
                      v-if="!isCustomer && !arg.event.extendedProps.isDisabled"
                      @click="onDelete($event, arg.event.extendedProps)"
                      >mdi-delete</v-icon
                    >
                  </template>
                  <span>You can only edit or delete the last 6 days.</span>
                </v-tooltip>
                <div v-else>
                  <v-icon
                    class="action-icon"
                    v-if="!isCustomer && !arg.event.extendedProps.isDisabled"
                    @click="onDelete($event, arg.event.extendedProps)"
                    >mdi-delete</v-icon
                  >
                </div>
                <div v-if="!isCustomer">
                  <v-icon
                    v-if="arg.event.extendedProps.type === 'timesheet'"
                    icon
                    class="action-icon"
                    @click="onClone($event, arg.event.extendedProps)"
                    >mdi-content-copy</v-icon
                  >
                </div>
                <div v-if="isAdmin || isCustomer">
                  <v-icon
                    v-if="arg.event.extendedProps.type === 'timesheet' && !arg.event.isDisabled && isLessThanSixDays(arg.event.end)"
                    class="action-icon"
                    @click="onAdjustment($event, arg.event.extendedProps)"
                    >mdi-update</v-icon
                  >
                </div>
                <div class="effort">
                  <span v-if="arg.event.extendedProps.type === 'timesheet'">
                    <span class="float-right">{{ arg.event.extendedProps.originalObject.Effort }}H </span><br />
                    <span class="float-right" v-if="arg.event.extendedProps.originalObject.Adjustment">
                      {{ arg.event.extendedProps.originalObject.Adjustment > 0 ? `+` : `` }}{{ arg.event.extendedProps.originalObject.Adjustment }}H
                    </span>
                  </span>
                  <span class="float-right" v-else> {{ arg.event.extendedProps.originalObject.Hours }}H </span>
                </div>
              </div>
            </div>

            <div class="new-event event" v-else-if="arg.event.extendedProps.type === 'event' && !isCustomer">
              <div class="event__title">
                <span>New Event</span>
              </div>
              <div class="event__body">
                <div class="event__add add--timesheet" @click="registerTimesheet(arg.event)">Add TimeSheet</div>
                <div class="event__add add--leave" @click="registerLeave(arg.event)">Add Leave</div>
              </div>
            </div>
          </template>
        </FullCalendar>
        <!-- <v-calendar
          style="height: calc(100vh - 248px); min-width: 1200px"
          :dark="!isAdmin && !isCustomer"
          ref="calendar"
          v-model="value"
          :weekdays="weekday"
          view-mode="week"
          :events="events"
          event-overlap-mode="column"
          first-day-of-week="1"
          :event-overlap-threshold="30"
          :interval-format="intervalFormat"
          @click:event="onEventClick"
          :locale-first-day-of-year="4"
          :interval-height="80"
          hide-header
        >
          <template v-slot:day-label-header="day">
            <div class="day-label-header" :class="{ present: day.present }">{{ day.date }}</div>
          </template>
          <template v-slot:event="{ day, allDay, event }">
            <span>{{day}}</span>
            <div class="total-hours event" v-if="event.type === 'total-hours'">
              <div class="event-container">
                <div class="event__header">
                  {{ event.name }}
                </div>
                <div class="event__body">
                  <div class="commitment" v-for="c of event.originalObject" :key="c.commitmentName">
                    -&nbsp;{{ c.Name }} : {{ hoursOfCommitment(c.id, event.start.getDay()) }} Hours
                  </div>
                </div>
              </div>
            </div>
            <div
              class="event"
              v-else-if="event.type === 'leave' || event.type === 'timesheet'"
              :style="{ background: `${event.backgroundColor} !important` }"
            >
            {{ event }}
            {{ allDay }}
            {{ day }}
              <div class="event__title">
                <span>
                  {{ event.type === "timesheet" ? "Timesheet" : "Leave" }}
                </span>
              </div>
              <div class="event__body">
                <div class="event__name">
                  {{ event.name }}
                </div>
                <div class="event__description">
                  {{ event.description }}
                </div>
              </div>
              <div class="event__action mr-3">
                <v-tooltip top v-if="!isLessThanSixDays(event.end)">
                  <template v-slot:activator="{ props }">
                    <div v-bind="props">
                      <v-btn icon :disabled="true" class="delete-icon" v-if="!isCustomer && !event.isDisabled" @click="onDelete($event, event)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <span>You can only edit or delete the last 6 days.</span>
                </v-tooltip>
                <div v-else>
                  <v-btn icon class="delete-icon" v-if="!isCustomer && !event.isDisabled" @click="onDelete($event, event)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
                <div v-if="!isCustomer">
                  <v-btn v-if="event.type === 'timesheet'" icon class="delete-icon" @click="onClone($event, event)">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </div>
                <div v-if="isAdmin || isCustomer">
                  <v-btn
                    v-if="event.type === 'timesheet' && !event.isDisabled && isLessThanSixDays(event.end)"
                    icon
                    class="delete-icon"
                    @click="onAdjustment($event, event)"
                  >
                    <v-icon>mdi-update</v-icon>
                  </v-btn>
                </div>
                <div class="effort">
                  <span v-if="event.type === 'timesheet'">
                    <span class="float-right">{{ event.originalObject.Effort }}H </span><br />
                    <span class="float-right" v-if="event.originalObject.Adjustment">
                      {{ event.originalObject.Adjustment > 0 ? `+` : `` }}{{ event.originalObject.Adjustment }}H
                    </span>
                  </span>
                  <span class="float-right" v-else> {{ event.originalObject.Hours }}H </span>
                </div>
              </div>
            </div>

            <div class="new-event event" v-else-if="event.type === 'event' && !isCustomer">
              <div class="event__title">
                <span>New Event</span>
              </div>
              <div class="event__body">
                <div class="event__add add--timesheet" @click="registerTimesheet(event)">Add TimeSheet</div>
                <div class="event__add add--leave" @click="registerLeave(event)">Add Leave</div>
              </div>
            </div>
          </template>
        </v-calendar> -->
      </v-card-text>
    </v-card>
    <div class="cm-color-list" v-if="!checkLoading">
      <div v-for="cm in getFilteredCommitmentList()" :key="cm.id" class="cm-item">
        <span class="color-box" :style="{ background: cm.color }"></span>
        <span> {{ cm.Name }} </span>
      </div>
    </div>
    <v-card class="mt-3" v-if="!checkLoading">
      <v-card-title>Total Hours Of This Week: {{ removeDecimals(totalWeekHours) }} Hours</v-card-title>
      <v-card-text>
        <template v-if="commitmentList && commitmentList.length">
          <div class="week-statistic">
            <div class="commitment-names">
              <div class="commitment-item commitment-total"></div>
              <div v-for="commitment in listOfNonZeroCommitments" :key="commitment.id" md="12" class="commitment-item text-left">
                <strong>{{ commitment.Name }}</strong>
                &nbsp;
                <v-icon v-if="allTimesheetsOfCommitmentHaveBeenApproved(commitment.id)" color="success" x-small>mdi-lock</v-icon>
                <v-icon v-else color="error" x-small>mdi-lock-open</v-icon>
                &nbsp;:
              </div>
              <div v-for="commitment in listOfZeroCommitments" :key="commitment.id" md="12" class="commitment-item text-left">
                <strong>{{ commitment.Name }}</strong> &nbsp;:
              </div>
            </div>
            <div class="chart-container">
              <div class="chart chart--show-percent">
                <p
                  class="chart-item"
                  v-for="commitment in listOfNonZeroCommitments"
                  :style="'width:' + (200 * hoursOfCommitment(commitment.id)) / totalWeekHours + '%;'"
                  :key="commitment.id"
                >
                  {{ ((100 * hoursOfCommitment(commitment.id)) / totalWeekHours).toFixed() + "%" }}
                </p>
              </div>
              <div class="chart">
                <span
                  class="chart-item"
                  v-for="(commitment, index) in listOfNonZeroCommitments"
                  :style="`width:${(200 * hoursOfCommitment(commitment.id)) / totalWeekHours}%; background-color:${commitment.color}`"
                  :key="commitment.id"
                ></span>
                <span class="chart-item" v-for="commitment in listOfZeroCommitments" :style="'width: 0;'" :key="commitment.id"></span>
              </div>
              <div class="chart chart--arrow" style="display: flex">
                <span
                  class="chart-item chart-item--arrow"
                  v-for="(commitment, index) in listOfNonZeroCommitments"
                  :key="commitment.id"
                  ref="arrowContainer"
                  :style="calcArrowContainerStyle(index)"
                >
                  <span
                    class="arrow-item"
                    :class="(index + 1) % 2 === 0 ? 'red-border' : 'orange-border'"
                    :style="`width:${arrowWidths[index]}px; border-color:${commitment.color}`"
                    ><span class="hours">{{ removeDecimals(hoursOfCommitment(commitment.id)) }} Hours</span></span
                  >
                </span>
                <span
                  class="chart-item chart-item--arrow chart-item--zero"
                  v-for="(commitment, index) in listOfZeroCommitments"
                  :key="commitment.id"
                  :style="'height: ' + (54 + listOfNonZeroCommitments.length * 46 + (index + 1) * 46) + 'px'"
                >
                  <span class="arrow-item" :style="'width: 100%;'"
                    ><span class="hours">{{ hoursOfCommitment(commitment.id) }} Hours</span></span
                  >
                </span>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <v-row>
            <v-col md="12" class="text-left">
              <strong><span class="red--text">This user hasn't any active commitment!</span></strong>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
    </v-card>
    <v-dialog persistent v-model="showRemoveConfirm" @keydown.esc="showRemoveConfirm = false" max-width="400px">
      <confirm-dialog @confirm="confirmDelete" @cancel="showRemoveConfirm = false" :loading="isDeleting" :message="confirmModel"></confirm-dialog>
    </v-dialog>
    <v-dialog persistent v-model="showAdminActionConfirm" @keydown.esc="showAdminActionConfirm = false" max-width="400px">
      <confirm-dialog
        v-if="adminActionFunction"
        @confirm="adminActionFunction"
        @cancel="showAdminActionConfirm = false"
        :loading="isDeleting"
        :message="adminActionModel"
      />
    </v-dialog>
    <v-dialog persistent v-if="showLeaveDialog" v-model="showLeaveDialog" @keydown.esc="showLeaveDialog = false" max-width="600px">
      <RegisterLeave
        v-if="selectedLeave && selectedTeammember"
        @cancel="showLeaveDialog = false"
        @saved="leaveSaved"
        @showError="showErrorMessage"
        :selectedTeammember="selectedTeammember"
        :leaveInfo="selectedLeave"
        :commitments="commitmentList"
        :isAdmin="isAdmin"
      />
    </v-dialog>
    <v-dialog persistent max-width="100%" v-if="showRegisterTimesheet" v-model="showRegisterTimesheet" @keydown.esc="cancel">
      <TimesheetRegister
        :isAdmin="isAdmin"
        :teamMemberInfo="selectedTeammember"
        :date="registerDate"
        :tmCommitments="commitmentList"
        :timesheet="selectedTimesheet"
        :userProjects="userProjects"
        :regLoading="regLoading"
        :commitmentColors="commitmentColors"
        @cancel="cancelRegister"
        @errorRaised="errorRaised"
        @confirmTimesheet="confirmTimesheet"
        @editTimesheet="editTimesheet"
      ></TimesheetRegister>
    </v-dialog>
    <v-dialog persistent v-if="showCloneDialog" v-model="showCloneDialog" @keydown.esc="cancelClone" max-width="600px">
      <timesheet-clone
        @showErrorMessage="showErrorMessage"
        @cancel="cancelClone"
        :isAdmin="isAdmin"
        @confirmClone="confirmClone"
        :timesheetInfo="selectedTimesheet"
      ></timesheet-clone>
    </v-dialog>
    <v-dialog
      persistent
      v-if="showAdjustmentDialog && selectedTimesheet"
      v-model="showAdjustmentDialog"
      @keydown.esc="showAdjustmentDialog = false"
      max-width="400px"
    >
      <adjustment
        @cancel="showAdjustmentDialog = false"
        @saved="updatedAdjustment"
        @showError="showErrorMessage"
        :id="selectedTimesheet.id"
        :ad="selectedTimesheeatAd"
      ></adjustment>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Vue, { defineComponent } from "vue";
import Timesheet from "../../models/Timesheet";
import TimesheetClone from "./TimesheetClone.vue";
import Leave from "../../models/Leave";
import ConfirmDialog from "../ConfirmDialog.vue";
import RegisterLeave from "./RegisterLeave.vue";
import TimesheetRegister from "./TimesheetRegister.vue";
import Utils from "../../utils/Utils";
import { Activity } from "../../models/Activity";
import Project from "../../models/Project";
import moment from "moment";
import ActivityService from "../../services/ActivityService";
import Adjustment from "./Adjustment.vue";
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import momentPlugin from "@fullcalendar/moment";
import {
  CommitmentModel,
  CommitmentModelStatusV2Enum,
  LeaveApi,
  LeaveDetailResponseModel,
  TimesheetApi,
  TimesheetDetailResponseModel,
} from "../../services/openApi/api";
const leaveApi = new LeaveApi();
const timesheetApi = new TimesheetApi();
interface CalendarEvent {
  title: string;
  description: string;
  start: Date;
  end: Date;
  color: string;
  backgroundColor?: string;
  timed: boolean;
  type: "timesheet" | "leave" | "event" | "total-hours";
  originalObject: Timesheet | CommitmentModel[] | Leave | null;
  isOpen?: boolean;
  commitment?: string;
  isDisabled: boolean;
  allDay?: boolean | null;
  classNames?: String[];
  id: string;
}
export default defineComponent({
  components: {
    ConfirmDialog,
    RegisterLeave,
    TimesheetRegister,
    TimesheetClone,
    Adjustment,
    FullCalendar,
  },
  props: {
    cloneTimesheetId: {
      type: String,
      default: "",
      required: false,
    },
    userProjects: {
      required: false,
      type: Array as () => Project[],
    },
    showRegister: {
      type: Boolean,
      default: false,
    },
    regLoading: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    isCustomer: {
      type: Boolean,
      default: false,
    },
    timesheetsVersion: {
      type: Number,
    },
    selectedTeammember: {
      type: Object,
    },
    dateOffset: {
      type: Number,
    },
    selectedCommitment: {
      type: Object,
    },
    finishedCloneProcess: {
      type: Boolean,
    },
    fetchAllCommitmentsService: {
      type: Function,
    },
    fetchTimeSheetsService: {
      type: Function,
    },
    fetchLeavesService: {
      type: Function,
    },
  },
  data() {
    return {
      calendarOptions: {
        eventClick: (info: any) => {
          this.onEventClick(info);
        },
        eventMouseEnter: (info: any) => {
          if (["timesheet", "leave"].includes(info.event.extendedProps.type)) {
            const duration = moment.duration(moment(info.event.end).diff(moment(info.event.start)));
            if (duration.asMinutes() < 120) {
              const extraDuration = 120 - duration.asMinutes();
              const todayEvents = (this.$refs.fullCalendar as any).calendar
                .getEvents()
                .filter(
                  (event: any) =>
                    moment(info.event.start).toDate().toDateString() == moment(event.start).toDate().toDateString() &&
                    moment(event.start) > moment(info.event.start) &&
                    !event.allDay &&
                    event.extendedProps.type != "event"
                );
              info.event.setEnd(moment(info.event.end).add(extraDuration, "minutes").toDate());
              info.event.setExtendedProp("extraDuration", extraDuration);
              if (todayEvents.length > 0) {
                todayEvents.forEach((element: any) => {
                  element.setStart(moment(element.start).add(extraDuration, "minutes").toDate(), { maintainDuration: true });
                });
              }
            }
          }
        },
        eventMouseLeave: (info: any) => {
          if (["timesheet", "leave"].includes(info.event.extendedProps.type)) {
            let extraDuration: Number = 0;
            if ("extraDuration" in info.event.extendedProps) {
              extraDuration = info.event.extendedProps.extraDuration;
            }
            if (extraDuration != 0) {
              const todayEvents = (this.$refs.fullCalendar as any).calendar
                .getEvents()
                .filter(
                  (event: any) =>
                    moment(info.event.start).toDate().toDateString() == moment(event.start).toDate().toDateString() &&
                    moment(event.start) > moment(info.event.start) &&
                    !event.allDay &&
                    event.extendedProps.type != "event"
                );
              info.event.setEnd(moment(info.event.end).add(-extraDuration, "minutes").toDate());
              info.event.setExtendedProp("extraDuration", null);
              if (todayEvents.length > 0) {
                todayEvents.forEach((element: any) => {
                  element.setStart(moment(element.start).add(-extraDuration, "minutes").toDate(), { maintainDuration: true });
                });
              }
            }
          }
        },
        //themeSystem: !this.isAdmin && !this.isCustomer ? "standard" : "darkly",
        scrollTime: false,
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, momentPlugin],
        selectable: false,
        allDayContent: "",
        overlap: false,
        //allDaySlot: false,
        headerToolbar: {
          left: false,
          center: false,
          right: false,
        },
        slotDuration: { hours: 1 },
        slotLabelInterval: { hours: 1 },
        slotLabelFormat: "H[h]",
        events: [],
        initialView: "timeGridWeek",
        views: {
          timeGridWeek: {
            dayHeaderContent: function (arg: any) {
              const fLine = document.createElement("i");
              fLine.innerHTML = moment(arg.date).format("ddd");
              const sLine = document.createElement("i");
              sLine.innerHTML = moment(arg.date).format("YYYY-MM-DD");
              return { domNodes: [fLine, document.createElement("br"), sLine] };
            },
          },
        },
        // editable: true,
        // selectMirror: true,
        // dayMaxEvents: true,
        weekends: true,
        expandRows: false,
        // select: this.handleDateSelect,
        // eventsSet: this.handleEvents,
        firstDay: 1 /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */,
      },
      showRegisterTimesheet: false,
      selectedTimesheeatAd: 0,
      showAdjustmentDialog: false,
      checkLoading: false,
      colorPalette: ["#9e0142", "#d53e4f", "#f46d43", "#fdae61", "#e6f598", "#abdda4", "#66c2a5", "#3288bd", "#5e4fa2"],
      showArrows: false,
      showAdminActionConfirm: false,
      adminActionModel: {
        title: "Remove timesheet",
        text: "Are you sure?",
      },
      adminActionFunction: undefined as Function | undefined,
      showRemoveConfirm: false,
      editingTimesheetId: "",
      registerDate: "",
      showCloneDialog: false,
      isDeleting: false,
      dayOffset: this.dateOffset ? this.dateOffset : 0,
      showLeaveDialog: false,
      newEventStartHours: [0, 0, 0, 0, 0, 0, 0],
      allCommitments: [] as CommitmentModel[],
      commitmentList: [] as CommitmentModel[],
      leaveList: [] as Leave[],
      timesheetList: [] as Timesheet[],
      selectedLeave: null as LeaveDetailResponseModel | null,
      itemRemove: {} as Timesheet,
      selectedTimesheet: {} as TimesheetDetailResponseModel,
      commitmentColors: [] as Array<{ id: string; color: string }>,
      arrowWidths: [] as number[],
      activities: [] as Activity[],
      groupByDateTimesheets: {} as any,
      weekday: Utils.getWeekDays(),
      value: null,
      events: [] as any[],
      confirmModel: {
        title: "Remove timesheet",
        text: "Are you sure?",
      },
    };
  },
  async mounted() {
    this.setDefaultGroupByDateTimesheets();
    await this.loadData(true);
  },
  methods: {
    errorRaised(event: any) {},
    cancel(event: any) {},
    cancelRegister() {
      this.selectedTimesheet = {} as TimesheetDetailResponseModel;
      this.$emit("cancelRegister");
    },
    setDefaultGroupByDateTimesheets() {
      this.groupByDateTimesheets = {
        "1": [],
        "2": [],
        "3": [],
        "4": [],
        "5": [],
        "6": [],
        "0": [],
      } as { [key: string]: Timesheet[] };
    },
    async loadData(isMounted = false) {
      this.resetModals();
      try {
        this.checkLoading = true;
        if (isMounted) {
          if (localStorage.dayOffset && localStorage.dayOffset !== 0) {
            this.dayOffset = localStorage.dayOffset;
            //(this.$refs.calendar as any).move(this.dayOffset);
          }
          await this.fetchActivities();
          await this.fetchAllCommitments();
        }
        const model = { teamMemberId: this.selectedTeammember?.Id, startDate: this.startDate, endDate: this.endDate };
        if (this.fetchTimeSheetsService && this.fetchLeavesService) {
          const tmList = await this.fetchTimeSheetsService(model);
          const lList = await this.fetchLeavesService(model);
          this.prepareTimesheets(tmList);
          this.prepareLeaves(lList);
          this.checkLoading = false;
        }
      } finally {
        this.checkLoading = false;
      }
    },
    updatedAdjustment() {
      this.loadData();
    },
    async fetchActivities() {
      this.activities = await await ActivityService.getActivityList();
    },
    async fetchAllCommitments() {
      if (this.fetchAllCommitmentsService) {
        const allCommitments = await this.fetchAllCommitmentsService();
        this.allCommitments = allCommitments;
        this.fetchCommitments();
      }
    },
    getFilteredCommitmentList() {
      return (this as any).commitmentList
        .filter((item: any) => this.timesheetList.some((ts) => ts.CommitmentId == item.id))
        .sort((a: any, b: any) => {
          return a.Name.toLowerCase().localeCompare(b.Name);
        });
    },
    onEventClick(day: any) {
      day.jsEvent.stopPropagation();
      const calendarEvent = day.event;
      if (calendarEvent.extendedProps.type === "timesheet") {
        if (!calendarEvent.extendedProps.isDisabled) this.editTimesheet(calendarEvent.extendedProps.originalObject as Timesheet);
      } else if (calendarEvent.extendedProps.type === "leave") {
        this.editLeave(calendarEvent.extendedProps.originalObject as Leave);
      } else if (calendarEvent.extendedProps.type === "total-hours") {
        // const target: HTMLElement = day.el;
        // document.querySelectorAll(".v-calendar-daily_head-day .v-event").forEach((element) => {
        //   (element as HTMLElement).style.top = "";
        // });
        // if (calendarEvent.extendedProps.isOpen) {
        //   calendarEvent.extendedProps.isOpen = false;
        //   (target.parentElement as HTMLElement).style.top = "";
        // } else {
        //   this.events.map((t) => (t.isOpen = false));
        //   this.events = [...this.events];
        //   calendarEvent.extendedProps.isOpen = true;
        //   const clientHeight = (target as HTMLElement).clientHeight > 100 ? (target as HTMLElement).clientHeight : 100;
        //   (target.parentElement as HTMLElement).style.top = `calc(100vh - ${248 + clientHeight}px)`;
        //   (target.parentElement as HTMLElement).style.setProperty("min-height", 248 + (target as HTMLElement).clientHeight + "px", "important");
        // }
      }
    },
    decimalCount(num: any) {
      const numStr = String(num);
      if (numStr.includes(".")) {
        return numStr.split(".")[1].length;
      }
      return 0;
    },
    removeDecimals(value: any) {
      if (value && this.decimalCount(value) > 2 && value !== 0) {
        return Number(value).toFixed(2);
      }
      return value;
    },
    async editLeave(item: Leave) {
      try {
        this.checkLoading = true;
        var LeaveItem = { ...(item as any) };
        var response;
        LeaveItem.Date = LeaveItem.Date.toISOString();
        if (!this.isAdmin) {
          response = await leaveApi.getLeaveById(item.id);
        } else {
          response = await leaveApi.getLeaveByIdForAdmin(item.id);
        }
        if (response) {
          this.checkLoading = false;
          if (this.isAdmin || this.isCustomer) {
            response.data.IsLocked = false;
          }
          this.selectedLeave = response.data;
          this.showLeaveDialog = true;
          if (response.data.IsLocked) {
            this.showErrorMessage(response.data.Message);
          }
        }
      } finally {
        this.checkLoading = false;
      }
      // this.selectedLeave = item;
      // this.showLeaveDialog = true;
    },
    initAdminActionConfirm(title: string, text: string, func: Function) {
      this.checkLoading = false;
      this.adminActionModel = {
        title,
        text,
      };
      this.adminActionFunction = func;

      this.showAdminActionConfirm = true;
    },
    closeAdminActionConfirm() {
      this.adminActionModel = {
        title: "",
        text: "",
      };
      this.adminActionFunction = undefined;

      this.showAdminActionConfirm = false;
    },

    async editTimesheet(item: Timesheet) {
      this.$emit("cancelRegister");
      try {
        this.checkLoading = true;
        var timesheetItem = item;
        var response;
        if (!this.isAdmin) {
          response = await timesheetApi.getById(item.id);
        } else {
          response = await timesheetApi.getByIdForAdmin(item.id);
        }
        this.checkLoading = false;
        if (this.isAdmin || this.isCustomer) {
          response.data.IsLocked = false;
        }
        this.editingTimesheetId = item.id;
        this.selectedTimesheet = response.data;
        this.registerDate = "";
        if (this.isAdmin && this.allTimesheetsOfCommitmentHaveBeenApproved(response.data.CommitmentId ?? "")) {
          this.initAdminActionConfirm("Edit Timesheet", "This commitment has approved by LineManager. Are you sure?", this.saveTimesheetAction);
        } else {
          this.saveTimesheetAction();
        }
        if (response.data.IsLocked) {
          this.showErrorMessage(response.data.Message);
        }
      } finally {
        this.checkLoading = false;
      }
    },
    saveTimesheetAction() {
      this.closeAdminActionConfirm();
      this.$emit("registerTimesheet");
    },
    registerTimesheet(event: CalendarEvent) {
      if (this.isLessThanSixDays(event.end)) {
        const day = new Date(event.end.getTime() + Math.abs(event.end.getTimezoneOffset() * 60000)).toISOString();
        this.registerDate = day.split("T")[0];
        this.editingTimesheetId = "";
        this.selectedTimesheet = {} as TimesheetDetailResponseModel;

        this.$emit("registerTimesheet");
      } else {
        this.showErrorMessage("You can't add timesheet less than 6 days from today!");
      }
    },
    showErrorMessage(message: any) {
      this.$emit("errorRaised", message);
    },
    registerLeave(event: CalendarEvent) {
      if (this.selectedTeammember) {
        this.selectedLeave = {
          Date: event.start,
          Description: "",
          CommitmentId: "",
          Hours: 0,
          id: "",
          Teammember: { id: this.selectedTeammember.Id, Name: this.selectedTeammember.Name },
          Type: "Annual",
        };
        this.showLeaveDialog = true;
      }
    },
    onClone(clickEvent: Event, event: CalendarEvent) {
      clickEvent.stopPropagation();
      this.selectedTimesheet = { ...(event.originalObject as TimesheetDetailResponseModel) };
      this.cloneTimesheet();
    },
    onAdjustment(clickEvent: Event, event: CalendarEvent) {
      clickEvent.stopPropagation();
      if (event.type === "timesheet") {
        this.selectedTimesheet = event.originalObject as TimesheetDetailResponseModel;
        if (this.isAdmin && this.allTimesheetsOfCommitmentHaveBeenApproved(this.selectedTimesheet.CommitmentId ?? "")) {
          this.initAdminActionConfirm(
            "Adjust Timesheet",
            "This commitment has approved by LineManager. Are you sure?",
            this.showAdjustmentDialogAction
          );
        } else {
          this.showAdjustmentDialogAction();
        }
      }
    },
    showAdjustmentDialogAction() {
      this.closeAdminActionConfirm();
      this.showAdjustmentDialog = true;
    },
    onDelete(clickEvent: Event, event: CalendarEvent) {
      clickEvent.stopPropagation();
      if (event.type === "timesheet") {
        this.removeTimesheet(event.originalObject as Timesheet);
      } else {
        this.removeLeave(event.originalObject as Leave);
      }
    },

    removeTimesheet(item: Timesheet): void {
      this.checkLoading = true;
      try {
        var timesheetItem = item;
        this.selectedLeave = null;
        this.itemRemove = item;
        if (this.isAdmin && this.allTimesheetsOfCommitmentHaveBeenApproved(timesheetItem.CommitmentId ?? "")) {
          this.initAdminActionConfirm("Remove Timesheet", "This commitment has approved by LineManager. Are you sure?", this.prepareRemoveConfirm);
        } else {
          this.prepareRemoveConfirm();
        }
      } finally {
        this.checkLoading = false;
      }
    },
    removeLeave(item: Leave) {
      this.selectedLeave = item;
      this.prepareRemoveConfirm();
    },
    prepareRemoveConfirm() {
      this.closeAdminActionConfirm();

      this.showRemoveConfirm = true;
      this.isDeleting = false;
    },
    cancelClone() {
      this.showCloneDialog = false;
      this.selectedTimesheet = {} as TimesheetDetailResponseModel;
    },
    cloneTimesheet(): void {
      this.showCloneDialog = true;
    },
    async confirmClone($model: any) {
      this.selectedTimesheet = $model.timesheet;
      await this.$emit("confirmClone", $model);
    },
    async confirmDelete() {
      this.isDeleting = true;
      if (this.selectedLeave) {
        this.$emit("deleteLeave", this.selectedLeave.id);
      } else if (this.itemRemove) {
        this.$emit("deleteTimesheet", this.itemRemove.id);
      }
    },
    async leaveSaved($model: Leave): Promise<void> {
      await this.$emit("confirmLeave", $model);
    },
    async confirmTimesheet(saveModel: any) {
      await this.$emit("confirmTimesheet", saveModel);
    },
    intervalFormat(interval: any) {
      return `${interval.start.getHours()} h`;
    },
    shuffle(array: any[]) {
      let currentIndex: number = array.length;
      let randomIndex: number;
      while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
      }
      return array;
    },
    fetchCommitments() {
      let commitments = [] as CommitmentModel[];
      if (this.selectedTeammember?.Id) {
        commitments = this.allCommitments.filter(
          (x) =>
            x.TeamMemberIds?.includes(this.selectedTeammember?.Id) &&
            ((!x.EndDate && x.StartDate && moment(x.StartDate).toDate() <= this.endDate) ||
              (x.EndDate && moment(x.EndDate).toDate() >= this.startDate && x.StartDate && moment(x.StartDate).toDate() <= this.endDate))
        );
      }
      if (commitments.length === 0) {
        this.showErrorMessage("Selected Teammember hasn't any active Commitment!");
      } else {
        this.commitmentList = commitments;
        let copyPallet = [...this.colorPalette];
        this.commitmentList.forEach((item) => {
          var color = copyPallet.length > 0 ? copyPallet[0] : "#" + ((Math.random() * 0xffffff) << 0).toString(16);
          (item as any).color = color;
          this.commitmentColors.push({ id: item.id ?? "", color: color });
          copyPallet.splice(0, 1);
        });
      }
    },
    onNextWeekClicked() {
      this.events = [];
      this.setDefaultGroupByDateTimesheets();
      if (this.$refs.fullCalendar) {
        this.goNextWeek();
        //(this.$refs.fullCalendar as any).calendar.next();
      }
    },
    onPrevWeekClicked() {
      this.events = [];
      this.setDefaultGroupByDateTimesheets();
      if (this.$refs.fullCalendar) {
        this.goPrevWeek();
        //(this.$refs.fullCalendar as any).calendar.next();
      }
    },
    resetEventStartHours() {
      this.newEventStartHours = [0, 0, 0, 0, 0, 0, 0];
    },
    async goNextWeek() {
      this.dayOffset++;
      localStorage.dayOffset = this.dayOffset;
      this.resetEventStartHours();
      if (this.selectedTeammember) {
        this.fetchCommitments();
        await this.loadData();
      }
    },
    async goPrevWeek() {
      this.dayOffset--;
      localStorage.dayOffset = this.dayOffset;
      this.resetEventStartHours();
      if (this.selectedTeammember) {
        this.fetchCommitments();
        await this.loadData();
      }
    },
    weekTitle(): string {
      return `${Utils.toVsDateFormat(this.startDate).replace(/-/gi, "/")} - ${Utils.toVsDateFormat(this.endDate).replace(/-/gi, "/")}`;
    },
    sortByName(a: any, b: any) {
      if (!a.Commitment || !b.Commitment) return 0;
      if (a.Commitment.Name.toLocaleLowerCase() < b.Commitment.Name.toLocaleLowerCase()) return -1;
      if (a.Commitment.Name.toLocaleLowerCase() > b.Commitment.Name.toLocaleLowerCase()) return 1;
      return 0;
    },
    generateEvents() {
      this.resetEventStartHours();
      let hoursCounter: number = 0;
      let currentDay: number = 0;
      const events: CalendarEvent[] = [];
      const userTimesheets = [...this.timesheetList, ...this.leaveList];
      userTimesheets.sort((a, b) => {
        let al = (a as any).Commitment ? (a as any).Commitment.Name.toLocaleLowerCase() : "zzz";
        let bl = (b as any).Commitment ? (b as any).Commitment.Name.toLocaleLowerCase() : "zzz";
        return new Date(a.Date as Date).getDate() - new Date(b.Date as Date).getDate() || al.localeCompare(bl);
      });

      userTimesheets.forEach((event: any, index: any) => {
        const isTimesheet = event["eventType"] === "timesheet";
        const first = event.Date ? event.Date : new Date();
        if (first.getDay() !== currentDay) {
          hoursCounter = 0;
        }
        currentDay = first.getDay();
        // this check is needed if all timesheets use time "hh:mm:ss"
        // if (first.getHours() === 0) {
        // }
        const HoursMinute = hoursCounter.toString().split(".");
        first.setHours(Number(HoursMinute[0]));
        let min = HoursMinute[1] && Number(HoursMinute[1]) == 5 ? 50 : Number(HoursMinute[1]);
        let minutes = HoursMinute[1] ? (60 * min) / 100 : 0;
        first.setMinutes(minutes);

        let eventEffort = isTimesheet ? event["Effort"] + event["Adjustment"] : event["Hours"];
        hoursCounter += eventEffort;
        this.newEventStartHours[currentDay] = hoursCounter;
        const second = event.Date ? new Date(event.Date.toDateString()) : new Date();
        let eventEndTime = moment.duration(hoursCounter, "h").asMilliseconds();
        second.setTime(second.getTime() + eventEndTime);
        let selectedCommitment = this.commitmentList.find((item) => item.id == (event as any).CommitmentId) as any;
        events.push({
          title: isTimesheet ? `${event["IssueNo"]} - ${event["Project"].Name} (${this.getActivityName(event["ActivityId"])})` : event["Type"],
          description: event.Description,
          start: first,
          end: second,
          color: isTimesheet ? "red" : "orange",
          backgroundColor: isTimesheet && selectedCommitment ? selectedCommitment.color : "orange",
          timed: true,
          isOpen: false,
          type: isTimesheet ? "timesheet" : "leave",
          originalObject: event,
          classNames: ["main-event"],
          commitment: event["Commitment"] ? event["Commitment"]["Name"].toLowerCase() : "zzz",
          isDisabled: event["isLocked"] && !this.isAdmin,
          id: event["id"],
        });
      });
      (this.calendarOptions.events as any) = events;
      this.events = events;
    },
    getActivityName(activityId: string) {
      return this.activities.find((item) => item.id == activityId)?.Value;
    },
    generateNewEvents() {
      const events: CalendarEvent[] = [];
      let start = new Date(this.startDate);
      start.setHours(0);
      start.setMinutes(0);
      start.setSeconds(0);
      for (const i of this.weekday) {
        const HoursMinute = this.newEventStartHours[i].toString().split(".");
        let min = HoursMinute[1] && Number(HoursMinute[1]) == 5 ? 50 : Number(HoursMinute[1]);
        let minutes = HoursMinute[1] ? (60 * min) / 100 : 0;
        start.setHours(Number(HoursMinute[0]) <= 22 ? Number(HoursMinute[0]) : 22);
        start.setMinutes(minutes);
        const end = new Date();
        end.setTime(start.getTime() + 1.5 * 60 * 60 * 1000);
        if (this.isLessThanSixDays(start) && this.newEventStartHours[i] <= 22) {
          events.push({
            title: "",
            description: "",
            start,
            end,
            color: "transparent",
            timed: true,
            type: "event",
            isOpen: false,
            originalObject: null,
            isDisabled: false,
            id: "",
          });
        }
        start = new Date(end);
        start.setHours(0);
        start.setDate(start.getDate() + 1);
      }
      (this.calendarOptions.events as any) = [...this.events, ...events];
      this.events = [...this.events, ...events];
    },
    generateCommimentEvents() {
      const events: CalendarEvent[] = [];
      let index = 0;
      for (const weekdayIndex of this.weekday) {
        const timesheets = this.groupByDateTimesheets[weekdayIndex];
        const date = new Date(this.startDate);
        let totalHours: number = 0;
        timesheets.forEach((t: any) => (totalHours += this.getTotalEffortOfTimesheet(t)));
        const commitments = [...this.commitmentList.filter((com: any) => timesheets.some((tim: any) => tim.CommitmentId === com.id))];
        date.setDate(date.getDate() + index);
        events.push({
          title: "Total: " + this.removeDecimals(totalHours) + " Hours",
          description: "asd",
          start: date,
          end: date,
          color: "red",
          timed: false,
          type: "total-hours",
          isOpen: false,
          originalObject: commitments,
          isDisabled: false,
          allDay: true,
          id: "",
        });
        index++;
      }
      (this.calendarOptions.events as any) = [...this.events, ...events];
      this.events = [...this.events, ...events];
    },
    allTimesheetsOfCommitmentHaveBeenApproved(commitmentId: string): boolean {
      const noneLockedTimesheetsOfCommitment = this.commitmentTimesheets(commitmentId).find((x) => !x.isLocked);
      return !noneLockedTimesheetsOfCommitment;
    },
    commitmentTimesheets(commitmentId?: string): Timesheet[] {
      return this.timesheetList.filter((x) => x.CommitmentId === commitmentId && x.Date && x.Date >= this.startDate && x.Date <= this.endDate);
    },
    hoursOfCommitment(commitmentId?: string, day?: number): number {
      let retVal = 0;
      if (day || day === 0) {
        const timesheets = this.groupByDateTimesheets[day];
        timesheets.filter((x: any) => x.CommitmentId === commitmentId).forEach((x: any) => (retVal += this.getTotalEffortOfTimesheet(x)));
        return retVal;
      } else {
        this.commitmentTimesheets(commitmentId).forEach((x) => (retVal += this.getTotalEffortOfTimesheet(x)));
        return retVal;
      }
    },
    getTotalEffortOfTimesheet(timesheet: any) {
      return timesheet.Adjustment ? timesheet.Effort + parseFloat(`${timesheet.Adjustment}`) : timesheet.Effort;
    },
    calcArrowContainerStyle(index: number) {
      let height: number = 54;
      let width: number = 0;
      let zIndex: number = 0;
      for (let i = 0; i <= index; i++) {
        zIndex = this.listOfNonZeroCommitments.length - i;
        height += 46;
        width += (100 * this.hoursOfCommitment(this.listOfNonZeroCommitments[i].id)) / this.totalWeekHours;
      }
      return { height: height + "px", width: width + "%", zIndex };
    },
    calcArrowStyle() {
      let width: number = 0;
      this.arrowWidths = [];
      this.$nextTick(() => {
        for (const c of this.listOfNonZeroCommitments) {
          if (this.$refs["arrowContainer"]) {
            const index = this.listOfNonZeroCommitments.indexOf(c);
            const parent: HTMLElement = (this.$refs["arrowContainer"] as any)[index];
            const parentWidth = parent.clientWidth;
            if (parent.previousSibling) {
              const currentWidth = parentWidth - (parent.previousSibling as HTMLElement).clientWidth;
              width = (parent.previousSibling as HTMLElement).clientWidth + currentWidth / 2;
            } else {
              width = parentWidth / 2;
            }
            this.showArrows = true;
            this.arrowWidths.push(width);
          }
        }
      });
    },
    isLessThanSixDays(date: any) {
      if (this.isAdmin || this.isCustomer) {
        return true;
      }
      const clickedDay = new Date(date);
      const today = new Date();
      today.setDate(today.getDate() - 7);
      return today < clickedDay;
    },
    prepareTimesheets(newVal: any) {
      this.setDefaultGroupByDateTimesheets();
      newVal.forEach((v: any) => this.groupByDateTimesheets[(v.Date as Date).getDay()].push(v));
      if (newVal && newVal.length > 0) {
        newVal = newVal.filter((x: any) => (x.Activity || x.ActivityId) && this.hasActiveCommitment(x.CommitmentId));
      }
      newVal.map((v: any) => (v["eventType"] = "timesheet"));
      this.timesheetList = newVal;
      this.resetEventStartHours();
      this.generateEvents();
      this.generateNewEvents();
      this.generateCommimentEvents();
    },
    prepareLeaves(newVal: any) {
      newVal.map((v: any) => (v["eventType"] = "leave"));
      this.leaveList = newVal;
      this.resetEventStartHours();
      this.generateEvents();
      this.generateNewEvents();
      this.generateCommimentEvents();
    },
    hasActiveCommitment(commitId: any) {
      const timeSheetCommitment = this.allCommitments.find((c) => c.id === commitId);
      const theDate = new Date();
      if (timeSheetCommitment && timeSheetCommitment.StartDate) {
        return !(theDate <= moment(timeSheetCommitment.StartDate).toDate());
      } else {
        return false;
      }
    },
    resetModals() {
      this.showLeaveDialog = false;
      this.showRemoveConfirm = false;
      this.showAdjustmentDialog = false;
    },
  },
  computed: {
    startDate(): Date {
      const startDate = moment().startOf("week").toDate();
      startDate.setHours(0, 0, 0, 0);
      startDate.setDate(startDate.getDate() + this.dayOffset * 7);
      setTimeout(() => {
        if ((this.$refs.fullCalendar as any).calendar) {
          (this.$refs.fullCalendar as any).calendar.gotoDate(startDate);
        }
      }, 5);

      return startDate;
    },
    endDate(): Date {
      const retVal = new Date(this.startDate.toString());
      retVal.setDate(retVal.getDate() + 6);
      return retVal;
    },
    listOfNonZeroCommitments(): CommitmentModel[] {
      this.calcArrowStyle();
      return this.commitmentList.filter((c) => this.hoursOfCommitment(c.id) > 0);
    },
    listOfZeroCommitments(): CommitmentModel[] {
      return this.commitmentList.filter((c) => this.hoursOfCommitment(c.id) === 0);
    },
    totalWeekHours(): number {
      let retVal = 0;
      this.timesheetList
        .filter((x) => x.Date && x.Date >= this.startDate && x.Date <= this.endDate)
        .forEach((item) => {
          retVal += this.getTotalEffortOfTimesheet(item);
        });
      return retVal;
    },
  },
  watch: {
    cloneTimesheetId(newVal) {
      this.selectedTimesheet.id = newVal;
    },
    async showRegister(newVal) {
      this.showRegisterTimesheet = newVal;
      if (newVal) {
        this.showCloneDialog = false;
      }
    },
    timesheetsVersion() {
      this.loadData();
    },
    finishedCloneProcess(newVal) {
      if (newVal) {
        this.showCloneDialog = false;
        this.loadData();
      }
    },
    dateOffset() {
      if (this.dateOffset || this.dateOffset === 0) {
        this.dayOffset = this.dateOffset;
      }
    },
  },
});
</script>

<style lang="scss">
.v-application {
  .timesheet-calendar {
    height: calc(100vh - 248px);
    min-width: 1200px;
    .main-event {
      border-bottom: 1px solid rgb(92, 92, 92) !important;
    }
    .fc-timegrid-col-frame {
      margin: 1px 5px 1px 2px;
    }
    .fc-timegrid-col-events {
      margin: 0 !important;
    }
    .fc-timegrid-cols {
      z-index: 1;
      .fc-timegrid-col-frame {
        pointer-events: fill;
        &:hover:not(:has(.main-event:hover)) {
          .new-event {
            opacity: 1;
          }
        }
      }
    }
    .fc-timegrid-slots tr {
      height: 80px;
      .fc-timegrid-slot-label {
        vertical-align: baseline !important;
      }
    }
    .fc-timegrid-event {
      box-shadow: none;
      margin-bottom: 0 !important;
      .fc-event-main {
        padding: 0 !important;
      }
    }
    .fc-timegrid-event-harness {
      cursor: pointer;
      width: 100% !important;
      border-radius: 0;
      border: none !important;

      transition: all 0.2s;
      left: 0% !important;
      overflow: hidden;
      &:not(:nth-last-child(-n + 2)) {
        //border-bottom: 1px solid #9e9e9e !important;
      }
      &:hover {
        z-index: 2 !important;
      }

      &.red {
        top: 0px !important;
        position: relative !important;
        background-color: #dc1e28 !important;
        border-bottom: 1px solid #9e9e9e !important;
        border-top: 1px solid #9e9e9e !important;
      }
      &.indigo {
        background-color: rgba(#9300ff, 1) !important;
      }
      &.orange {
        position: sticky !important;
        background-color: #ff9800 !important;
        border-bottom: 1px solid #9e9e9e !important;
        border-top: 1px solid #9e9e9e !important;
      }
    }
  }

  .v-calendar-daily_head-day {
    .v-event {
      position: absolute;
      top: calc(100vh - 268px);
      border-radius: 0;
      // color: black !important;
      min-height: 100px !important;
      transition: all 0.2s;
      z-index: 2;
      &:hover {
        top: calc(100vh - 268px);
      }
    }
  }

  .v-calendar-events .v-event-timed:hover ~ .v-event-timed.transparent {
    display: none;
  }
}
</style>

<style lang="scss" scoped>
.week-title {
  text-wrap: balance;
  text-align: center;
}

.day-label-header.present {
  font-weight: 700;
}
.total-hours {
  height: fit-content !important;
  .event-container {
    width: 100%;
    .event__header {
      background-color: white;
      font-weight: 600;
      font-size: 13px;
      padding: 0 10px;
      color: gray;
    }
  }
}
.new-event {
  background-color: white;
  opacity: 0;
  transition: all 0.2s;
  .event__body {
    display: flex;
    flex-direction: column;
    padding: 0;
  }
  .event__add {
    flex-grow: 1;
    opacity: 0.3;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    &:hover {
      opacity: 1;
    }
    &.add--timesheet {
      background-color: #dc1e28 !important;
    }
    &.add--leave {
      background-color: #ff9800 !important;
    }
  }
}

.event {
  display: flex;
  height: 100%;
  &:hover {
    .event__action {
      .action-icon {
        opacity: 1;
      }
    }
  }
  &__title {
    span {
      transform: rotate(-90deg);
      text-wrap: nowrap;
    }
    height: 100%;
    width: 15px;
    background-color: white;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 13px;
    color: gray;
  }
  &__body {
    padding: 5px 10px;
    flex-grow: 1;
    width: 100%;
  }
  &__header {
    display: flex;
  }
  &__name {
    white-space: initial;
    font-weight: 700;
  }
  &__description {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
  &__action {
    margin-left: auto;
    width: 20px;
    .effort {
      position: absolute;
      right: 5px;
      bottom: 0;
      font-size: 12px;
      font-weight: 600;
    }
    .action-icon {
      margin: 5px 5px 0 0;
      opacity: 0;
      font-size: 24px;
    }
  }
}
@media (max-width: 425px) {
  .week-title {
    font-size: 16px;
  }
}
</style>

<style scoped lang="scss">
.cm-color-list {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  .cm-item {
    display: flex;
    gap: 5px;
    align-items: center;
    .color-box {
      width: 10px;
      height: 10px;
    }
  }
}
.week-statistic {
  display: flex;
  .commitment-names {
    padding-right: 10px;
    .commitment-item {
      &:nth-child(2) {
        margin-top: 54px;
      }
      &.commitment-total {
        justify-content: center;
        color: white;
        font-size: 17px;
        font-weight: 700;
      }
      height: 46px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
.chart-container {
  flex-grow: 1;
  .chart {
    display: flex;
    height: 5px;
    &--show-percent {
      height: 22px;
      text-align: center;
    }
    .chart-item--arrow {
      display: flex;
      position: absolute;
      top: 0;
      left: 0;
      &.chart-item--zero {
        right: 0;
      }
      .arrow-item {
        height: 100%;
        width: 50%;
        border-right: 1px solid;
        border-bottom: 1px solid;
        &.red-border {
          border-color: #dc1e28;
        }
        &.orange-border {
          border-color: #ff9800;
        }
        .hours {
          position: absolute;
          bottom: 0;
          width: 100px;
        }
      }
    }
  }
  .chart--arrow {
    position: relative;
  }
}
</style>
